// @flow
import type { FluxStandardAction } from 'modules/helper';
import { HomeActionTypes } from './actionTypes';

// TODO: Define types, instead of any
export type HomeState = {
  banner: any,
  pageBanner: any,
  contacts: any,
  header: any,
  verticals: any,
  siteSettings: any,
  loading: {
    banner: boolean,
    pageBanner: boolean,
    contacts: boolean,
    header: boolean,
    verticals: boolean,
    siteSettings: boolean,
  },
  error: {
    banner: string | null,
    pageBanner: string | null,
    contacts: string | null,
    header: string | null,
    verticals: string | null,
    siteSettings: string | null,
  },
};

const initialState: HomeState = {
  banner: null,
  pageBanner: null,
  contacts: null,
  verticals: null,
  header: null,
  siteSettings: null,
  loading: {
    banner: false,
    pageBanner: false,
    contacts: false,
    verticals: false,
    siteSettings: false,
  },
  error: {
    banner: null,
    pageBanner: null,
    contacts: null,
    verticals: null,
    siteSettings: null,
  },
};

export const HomeReducer = (
  state: HomeState = initialState,
  action: FluxStandardAction
) => {
  const { type, payload, error } = action;

  switch (type) {
    case HomeActionTypes.BANNER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, banner: true },
        error: { ...state.error, banner: null },
      };
    case HomeActionTypes.BANNER.SUCCESS:
      return {
        ...state,
        banner: payload,
        loading: { ...state.loading, banner: false },
      };
    case HomeActionTypes.BANNER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, banner: false },
        error: { ...state.error, banner: error },
      };
    case HomeActionTypes.HEADER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, header: true },
        error: { ...state.error, header: null },
      };
    case HomeActionTypes.HEADER.SUCCESS:
      return {
        ...state,
        header: payload.data,
        loading: { ...state.loading, header: false },
      };
    case HomeActionTypes.HEADER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, header: false },
        error: { ...state.error, header: error },
      };
    case HomeActionTypes.HEADER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, header: true },
        error: { ...state.error, header: null },
      };
    case HomeActionTypes.HEADER.SUCCESS:
      return {
        ...state,
        header: payload.data,
        loading: { ...state.loading, header: false },
      };
    case HomeActionTypes.HEADER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, header: false },
        error: { ...state.error, header: error },
      };
    case HomeActionTypes.HEADER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, header: true },
        error: { ...state.error, header: null },
      };
    case HomeActionTypes.HEADER.SUCCESS:
      return {
        ...state,
        header: payload.data,
        loading: { ...state.loading, header: false },
      };
    case HomeActionTypes.HEADER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, header: false },
        error: { ...state.error, header: error },
      };
    case HomeActionTypes.CONTACTS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, contacts: true },
        error: { ...state.error, contacts: null },
      };
    case HomeActionTypes.CONTACTS.SUCCESS:
      return {
        ...state,
        contacts: payload,
        loading: { ...state.loading, contacts: false },
      };
    case HomeActionTypes.CONTACTS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, contacts: false },
        error: { ...state.error, contacts: error },
      };
    case HomeActionTypes.VERTICALS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, verticals: true },
        error: { ...state.error, verticals: null },
      };
    case HomeActionTypes.VERTICALS.SUCCESS:
      return {
        ...state,
        verticals: payload,
        loading: { ...state.loading, verticals: false },
      };
    case HomeActionTypes.VERTICALS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, verticals: false },
        error: { ...state.error, verticals: error },
      };
    case HomeActionTypes.SITE_SETTINGS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, siteSettings: true },
        error: { ...state.error, siteSettings: null },
      };
    case HomeActionTypes.SITE_SETTINGS.SUCCESS:
      return {
        ...state,
        siteSettings: payload,
        loading: { ...state.loading, siteSettings: false },
      };
    case HomeActionTypes.SITE_SETTINGS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, siteSettings: false },
        error: { ...state.error, siteSettings: error },
      };
    default:
      return state;
  }
};
